// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/customer_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { ContractorOption, ContractStage, CustomerOption, CustomerSummary, CustomerSupplyPoint, KwPeriodList, PrivateGeneration, RetailerOption, SupplyPointDeleteBlockedReason } from "./customer_model_pb";
import { file_bffuser_v1_customer_model } from "./customer_model_pb";
import type { VoltageClass } from "./occto_master_model_pb";
import { file_bffuser_v1_occto_master_model } from "./occto_master_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/customer_service.proto.
 */
export const file_bffuser_v1_customer_service: GenFile = /*@__PURE__*/
  fileDesc("CiFiZmZ1c2VyL3YxL2N1c3RvbWVyX3NlcnZpY2UucHJvdG8SCmJmZnVzZXIudjEiFgoUTGlzdEN1c3RvbWVyc1JlcXVlc3QiRwoVTGlzdEN1c3RvbWVyc1Jlc3BvbnNlEi4KCWN1c3RvbWVycxgBIAMoCzIbLmJmZnVzZXIudjEuQ3VzdG9tZXJTdW1tYXJ5ImoKH0xpc3RDdXN0b21lclN1cHBseVBvaW50c1JlcXVlc3QSOQoJYXJlYV9jb2RlGAEgASgOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGVCCrpIB4IBBBABIABIAIgBAUIMCgpfYXJlYV9jb2RlIrwBChdHZXRDb250cmFjdFRyZW5kUmVxdWVzdBI5CglhcmVhX2NvZGUYASABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZUIKukgHggEEEAEgAEgAiAEBEiwKCWZyb21fZGF0ZRgCIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVCBrpIA8gBARIqCgd0b19kYXRlGAMgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBQgwKCl9hcmVhX2NvZGUivAEKEENvbnRyYWN0VHJlbmREYXkSHwoEZGF0ZRgBIAEoCzIRLmdvb2dsZS50eXBlLkRhdGUSJAoGbG93X2t3GAIgASgLMhQuZ29vZ2xlLnR5cGUuRGVjaW1hbBIlCgdoaWdoX2t3GAMgASgLMhQuZ29vZ2xlLnR5cGUuRGVjaW1hbBIrCg1leHRyYV9oaWdoX2t3GAQgASgLMhQuZ29vZ2xlLnR5cGUuRGVjaW1hbBINCgVjb3VudBgFIAEoBSLaAQoSQ29udHJhY3RUcmVuZEV2ZW50Eh8KBGRhdGUYASABKAsyES5nb29nbGUudHlwZS5EYXRlEjAKBGtpbmQYAiABKA4yIi5iZmZ1c2VyLnYxLkNvbnRyYWN0VHJlbmRFdmVudEtpbmQSFQoNY3VzdG9tZXJfbmFtZRgDIAEoCRIvCg12b2x0YWdlX2NsYXNzGAQgASgOMhguYmZmdXNlci52MS5Wb2x0YWdlQ2xhc3MSKQoLY29udHJhY3Rfa3cYBSABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsIpYBChBDb250cmFjdFRyZW5kS3BpEioKDGF2Z190b3RhbF9rdxgBIAEoCzIULmdvb2dsZS50eXBlLkRlY2ltYWwSKgoMbWluX3RvdGFsX2t3GAIgASgLMhQuZ29vZ2xlLnR5cGUuRGVjaW1hbBIqCgxtYXhfdG90YWxfa3cYAyABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsIq4BChhHZXRDb250cmFjdFRyZW5kUmVzcG9uc2USKgoEZGF5cxgBIAMoCzIcLmJmZnVzZXIudjEuQ29udHJhY3RUcmVuZERheRIuCgZldmVudHMYAiADKAsyHi5iZmZ1c2VyLnYxLkNvbnRyYWN0VHJlbmRFdmVudBIuCgNrcGkYAyABKAsyHC5iZmZ1c2VyLnYxLkNvbnRyYWN0VHJlbmRLcGlIAIgBAUIGCgRfa3BpIloKIExpc3RDdXN0b21lclN1cHBseVBvaW50c1Jlc3BvbnNlEjYKDXN1cHBseV9wb2ludHMYASADKAsyHy5iZmZ1c2VyLnYxLkN1c3RvbWVyU3VwcGx5UG9pbnQiYAooR2V0Q3VzdG9tZXJTdXBwbHlQb2ludEZvcm1PcHRpb25zUmVxdWVzdBI0CglhcmVhX2NvZGUYASABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZUIKukgHggEEEAEgACLRAQopR2V0Q3VzdG9tZXJTdXBwbHlQb2ludEZvcm1PcHRpb25zUmVzcG9uc2USNAoQcmV0YWlsZXJfb3B0aW9ucxgBIAMoCzIaLmJmZnVzZXIudjEuUmV0YWlsZXJPcHRpb24SNAoQY3VzdG9tZXJfb3B0aW9ucxgCIAMoCzIaLmJmZnVzZXIudjEuQ3VzdG9tZXJPcHRpb24SOAoSY29udHJhY3Rvcl9vcHRpb25zGAMgAygLMhwuYmZmdXNlci52MS5Db250cmFjdG9yT3B0aW9uIssGCiBDcmVhdGVDdXN0b21lclN1cHBseVBvaW50UmVxdWVzdBI/Cg5jb250cmFjdF9zdGFnZRgBIAEoDjIZLmJmZnVzZXIudjEuQ29udHJhY3RTdGFnZUIMukgJggEGEAEYARgCEigKFGV4aXN0aW5nX2N1c3RvbWVyX2lkGAIgASgJQgi6SAVyA7ABAUgAEiUKEW5ld19jdXN0b21lcl9uYW1lGAMgASgJQgi6SAVyAxjoB0gAEiQKDWNvbnRyYWN0b3JfaWQYBCABKAlCCLpIBXIDsAEBSAGIAQESNAoJYXJlYV9jb2RlGAUgASgOMhUuYmZmdHlwZXMudjEuQXJlYUNvZGVCCrpIB4IBBBABIAASLAoWcmV0YWlsZXJfYnVzaW5lc3NfY29kZRgGIAEoCUIHukgEcgIYBEgCiAEBEjsKDXZvbHRhZ2VfY2xhc3MYByABKA4yGC5iZmZ1c2VyLnYxLlZvbHRhZ2VDbGFzc0IKukgHggEEEAEgABIyChxzdXBwbHlfcG9pbnRfc3BlY2lmaWNfbnVtYmVyGAggASgJQge6SARyAhhASAOIAQESLgoLY29udHJhY3Rfa3cYCSABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsSASIAQESNAoRc3VwcGx5X3N0YXJ0X2RhdGUYCiABKAsyES5nb29nbGUudHlwZS5EYXRlQga6SAPIAQESLwoPc3VwcGx5X2VuZF9kYXRlGAsgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUgFiAEBEkEKEnByaXZhdGVfZ2VuZXJhdGlvbhgMIAEoCzIdLmJmZnVzZXIudjEuUHJpdmF0ZUdlbmVyYXRpb25CBrpIA8gBARIqChNuZXdfY29udHJhY3Rvcl9uYW1lGA0gASgJQgi6SAVyAxjoB0gGiAEBQgoKCGN1c3RvbWVyQhAKDl9jb250cmFjdG9yX2lkQhkKF19yZXRhaWxlcl9idXNpbmVzc19jb2RlQh8KHV9zdXBwbHlfcG9pbnRfc3BlY2lmaWNfbnVtYmVyQg4KDF9jb250cmFjdF9rd0ISChBfc3VwcGx5X2VuZF9kYXRlQhYKFF9uZXdfY29udHJhY3Rvcl9uYW1lIooBCiFDcmVhdGVDdXN0b21lclN1cHBseVBvaW50UmVzcG9uc2USIAoYY3VzdG9tZXJfc3VwcGx5X3BvaW50X2lkGAEgASgJEhMKC2N1c3RvbWVyX2lkGAIgASgJEi4KCnVwZGF0ZWRfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIj8KDlByb3NwZWN0TnVtYmVyEi0KHHN1cHBseV9wb2ludF9zcGVjaWZpY19udW1iZXIYASABKAlCB7pIBHICGEAilQYKIFVwZGF0ZUN1c3RvbWVyU3VwcGx5UG9pbnRSZXF1ZXN0EioKGGN1c3RvbWVyX3N1cHBseV9wb2ludF9pZBgBIAEoCUIIukgFcgOwAQESLgoLY29udHJhY3Rfa3cYAiABKAsyFC5nb29nbGUudHlwZS5EZWNpbWFsSACIAQESNAoRc3VwcGx5X3N0YXJ0X2RhdGUYAyABKAsyES5nb29nbGUudHlwZS5EYXRlQga6SAPIAQESLwoPc3VwcGx5X2VuZF9kYXRlGAQgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUgBiAEBEjgKD3Byb3NwZWN0X251bWJlchgFIAEoCzIaLmJmZnVzZXIudjEuUHJvc3BlY3ROdW1iZXJIAogBARI/ChNleHBlY3RlZF91cGRhdGVkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIGukgDyAEBEjkKCWFyZWFfY29kZRgHIAEoDjIVLmJmZnR5cGVzLnYxLkFyZWFDb2RlQgq6SAeCAQQQASAASAOIAQESQAoNdm9sdGFnZV9jbGFzcxgIIAEoDjIYLmJmZnVzZXIudjEuVm9sdGFnZUNsYXNzQgq6SAeCAQQQASAASASIAQESMgocc3VwcGx5X3BvaW50X3NwZWNpZmljX251bWJlchgJIAEoCUIHukgEcgIYQEgFiAEBEiwKFnJldGFpbGVyX2J1c2luZXNzX2NvZGUYCiABKAlCB7pIBHICGARIBogBARIxCgprd19wZXJpb2RzGAsgASgLMhguYmZmdXNlci52MS5Ld1BlcmlvZExpc3RIB4gBAUIOCgxfY29udHJhY3Rfa3dCEgoQX3N1cHBseV9lbmRfZGF0ZUISChBfcHJvc3BlY3RfbnVtYmVyQgwKCl9hcmVhX2NvZGVCEAoOX3ZvbHRhZ2VfY2xhc3NCHwodX3N1cHBseV9wb2ludF9zcGVjaWZpY19udW1iZXJCGQoXX3JldGFpbGVyX2J1c2luZXNzX2NvZGVCDQoLX2t3X3BlcmlvZHMiUwohVXBkYXRlQ3VzdG9tZXJTdXBwbHlQb2ludFJlc3BvbnNlEi4KCnVwZGF0ZWRfYXQYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wItABChVVcGRhdGVDdXN0b21lclJlcXVlc3QSHQoLY3VzdG9tZXJfaWQYASABKAlCCLpIBXIDsAEBEh8KDWN1c3RvbWVyX25hbWUYAiABKAlCCLpIBXIDGOgHEj8KE2V4cGVjdGVkX3VwZGF0ZWRfYXQYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wQga6SAPIAQESJAoNY29udHJhY3Rvcl9pZBgEIAEoCUIIukgFcgOwAQFIAIgBAUIQCg5fY29udHJhY3Rvcl9pZCJIChZVcGRhdGVDdXN0b21lclJlc3BvbnNlEi4KCnVwZGF0ZWRfYXQYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIoQECiBDb252ZXJ0UHJvc3BlY3RUb0NvbnRyYWN0UmVxdWVzdBIqChhjdXN0b21lcl9zdXBwbHlfcG9pbnRfaWQYASABKAlCCLpIBXIDsAEBEi0KHHN1cHBseV9wb2ludF9zcGVjaWZpY19udW1iZXIYAiABKAlCB7pIBHICGEASLAoWcmV0YWlsZXJfYnVzaW5lc3NfY29kZRgDIAEoCUIHukgEcgIYBEgAiAEBEi4KC2NvbnRyYWN0X2t3GAQgASgLMhQuZ29vZ2xlLnR5cGUuRGVjaW1hbEgBiAEBEjQKEXN1cHBseV9zdGFydF9kYXRlGAUgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZUIGukgDyAEBEi8KD3N1cHBseV9lbmRfZGF0ZRgGIAEoCzIRLmdvb2dsZS50eXBlLkRhdGVIAogBARI/ChNleHBlY3RlZF91cGRhdGVkX2F0GAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIGukgDyAEBEjEKCmt3X3BlcmlvZHMYCCABKAsyGC5iZmZ1c2VyLnYxLkt3UGVyaW9kTGlzdEgDiAEBQhkKF19yZXRhaWxlcl9idXNpbmVzc19jb2RlQg4KDF9jb250cmFjdF9rd0ISChBfc3VwcGx5X2VuZF9kYXRlQg0KC19rd19wZXJpb2RzIlMKIUNvbnZlcnRQcm9zcGVjdFRvQ29udHJhY3RSZXNwb25zZRIuCgp1cGRhdGVkX2F0GAEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCKGAQoXTWFya1Byb3NwZWN0TG9zdFJlcXVlc3QSKgoYY3VzdG9tZXJfc3VwcGx5X3BvaW50X2lkGAEgASgJQgi6SAVyA7ABARI/ChNleHBlY3RlZF91cGRhdGVkX2F0GAIgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEIGukgDyAEBIkoKGE1hcmtQcm9zcGVjdExvc3RSZXNwb25zZRIuCgp1cGRhdGVkX2F0GAEgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcCJXCilHZXRDdXN0b21lclN1cHBseVBvaW50RGVsZXRhYmlsaXR5UmVxdWVzdBIqChhjdXN0b21lcl9zdXBwbHlfcG9pbnRfaWQYASABKAlCCLpIBXIDsAEBIpsBCipHZXRDdXN0b21lclN1cHBseVBvaW50RGVsZXRhYmlsaXR5UmVzcG9uc2USEQoJZGVsZXRhYmxlGAEgASgIEkcKDmJsb2NrZWRfcmVhc29uGAIgASgOMiouYmZmdXNlci52MS5TdXBwbHlQb2ludERlbGV0ZUJsb2NrZWRSZWFzb25IAIgBAUIRCg9fYmxvY2tlZF9yZWFzb24ijwEKIERlbGV0ZUN1c3RvbWVyU3VwcGx5UG9pbnRSZXF1ZXN0EioKGGN1c3RvbWVyX3N1cHBseV9wb2ludF9pZBgBIAEoCUIIukgFcgOwAQESPwoTZXhwZWN0ZWRfdXBkYXRlZF9hdBgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBCBrpIA8gBASIjCiFEZWxldGVDdXN0b21lclN1cHBseVBvaW50UmVzcG9uc2UqiwEKFkNvbnRyYWN0VHJlbmRFdmVudEtpbmQSKQolQ09OVFJBQ1RfVFJFTkRfRVZFTlRfS0lORF9VTlNQRUNJRklFRBAAEiMKH0NPTlRSQUNUX1RSRU5EX0VWRU5UX0tJTkRfU1RBUlQQARIhCh1DT05UUkFDVF9UUkVORF9FVkVOVF9LSU5EX0VORBACMoYKCg9DdXN0b21lclNlcnZpY2USVAoNTGlzdEN1c3RvbWVycxIgLmJmZnVzZXIudjEuTGlzdEN1c3RvbWVyc1JlcXVlc3QaIS5iZmZ1c2VyLnYxLkxpc3RDdXN0b21lcnNSZXNwb25zZRJ1ChhMaXN0Q3VzdG9tZXJTdXBwbHlQb2ludHMSKy5iZmZ1c2VyLnYxLkxpc3RDdXN0b21lclN1cHBseVBvaW50c1JlcXVlc3QaLC5iZmZ1c2VyLnYxLkxpc3RDdXN0b21lclN1cHBseVBvaW50c1Jlc3BvbnNlEl0KEEdldENvbnRyYWN0VHJlbmQSIy5iZmZ1c2VyLnYxLkdldENvbnRyYWN0VHJlbmRSZXF1ZXN0GiQuYmZmdXNlci52MS5HZXRDb250cmFjdFRyZW5kUmVzcG9uc2USkAEKIUdldEN1c3RvbWVyU3VwcGx5UG9pbnRGb3JtT3B0aW9ucxI0LmJmZnVzZXIudjEuR2V0Q3VzdG9tZXJTdXBwbHlQb2ludEZvcm1PcHRpb25zUmVxdWVzdBo1LmJmZnVzZXIudjEuR2V0Q3VzdG9tZXJTdXBwbHlQb2ludEZvcm1PcHRpb25zUmVzcG9uc2USeAoZQ3JlYXRlQ3VzdG9tZXJTdXBwbHlQb2ludBIsLmJmZnVzZXIudjEuQ3JlYXRlQ3VzdG9tZXJTdXBwbHlQb2ludFJlcXVlc3QaLS5iZmZ1c2VyLnYxLkNyZWF0ZUN1c3RvbWVyU3VwcGx5UG9pbnRSZXNwb25zZRJ4ChlVcGRhdGVDdXN0b21lclN1cHBseVBvaW50EiwuYmZmdXNlci52MS5VcGRhdGVDdXN0b21lclN1cHBseVBvaW50UmVxdWVzdBotLmJmZnVzZXIudjEuVXBkYXRlQ3VzdG9tZXJTdXBwbHlQb2ludFJlc3BvbnNlElcKDlVwZGF0ZUN1c3RvbWVyEiEuYmZmdXNlci52MS5VcGRhdGVDdXN0b21lclJlcXVlc3QaIi5iZmZ1c2VyLnYxLlVwZGF0ZUN1c3RvbWVyUmVzcG9uc2USeAoZQ29udmVydFByb3NwZWN0VG9Db250cmFjdBIsLmJmZnVzZXIudjEuQ29udmVydFByb3NwZWN0VG9Db250cmFjdFJlcXVlc3QaLS5iZmZ1c2VyLnYxLkNvbnZlcnRQcm9zcGVjdFRvQ29udHJhY3RSZXNwb25zZRJdChBNYXJrUHJvc3BlY3RMb3N0EiMuYmZmdXNlci52MS5NYXJrUHJvc3BlY3RMb3N0UmVxdWVzdBokLmJmZnVzZXIudjEuTWFya1Byb3NwZWN0TG9zdFJlc3BvbnNlEpMBCiJHZXRDdXN0b21lclN1cHBseVBvaW50RGVsZXRhYmlsaXR5EjUuYmZmdXNlci52MS5HZXRDdXN0b21lclN1cHBseVBvaW50RGVsZXRhYmlsaXR5UmVxdWVzdBo2LmJmZnVzZXIudjEuR2V0Q3VzdG9tZXJTdXBwbHlQb2ludERlbGV0YWJpbGl0eVJlc3BvbnNlEngKGURlbGV0ZUN1c3RvbWVyU3VwcGx5UG9pbnQSLC5iZmZ1c2VyLnYxLkRlbGV0ZUN1c3RvbWVyU3VwcGx5UG9pbnRSZXF1ZXN0Gi0uYmZmdXNlci52MS5EZWxldGVDdXN0b21lclN1cHBseVBvaW50UmVzcG9uc2VCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bfftypes_v1_area, file_bffuser_v1_customer_model, file_bffuser_v1_occto_master_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * @generated from message bffuser.v1.ListCustomersRequest
 */
export type ListCustomersRequest = Message<"bffuser.v1.ListCustomersRequest"> & {
};

/**
 * Describes the message bffuser.v1.ListCustomersRequest.
 * Use `create(ListCustomersRequestSchema)` to create a new message.
 */
export const ListCustomersRequestSchema: GenMessage<ListCustomersRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 0);

/**
 * @generated from message bffuser.v1.ListCustomersResponse
 */
export type ListCustomersResponse = Message<"bffuser.v1.ListCustomersResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.CustomerSummary customers = 1;
   */
  customers: CustomerSummary[];
};

/**
 * Describes the message bffuser.v1.ListCustomersResponse.
 * Use `create(ListCustomersResponseSchema)` to create a new message.
 */
export const ListCustomersResponseSchema: GenMessage<ListCustomersResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 1);

/**
 * @generated from message bffuser.v1.ListCustomerSupplyPointsRequest
 */
export type ListCustomerSupplyPointsRequest = Message<"bffuser.v1.ListCustomerSupplyPointsRequest"> & {
  /**
   * @generated from field: optional bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode?: AreaCode;
};

/**
 * Describes the message bffuser.v1.ListCustomerSupplyPointsRequest.
 * Use `create(ListCustomerSupplyPointsRequestSchema)` to create a new message.
 */
export const ListCustomerSupplyPointsRequestSchema: GenMessage<ListCustomerSupplyPointsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 2);

/**
 * GetContractTrendRequest は契約推移の日別集計の条件。数えるのは区分「契約」の地点だけ。
 *
 * @generated from message bffuser.v1.GetContractTrendRequest
 */
export type GetContractTrendRequest = Message<"bffuser.v1.GetContractTrendRequest"> & {
  /**
   * 未指定は全エリアの合算。
   *
   * @generated from field: optional bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode?: AreaCode;

  /**
   * 集計する日付の範囲 (両端を含む)。範囲は 13 年度 (約 4,800 日) まで。
   *
   * @generated from field: google.type.Date from_date = 2;
   */
  fromDate?: Date;

  /**
   * @generated from field: google.type.Date to_date = 3;
   */
  toDate?: Date;
};

/**
 * Describes the message bffuser.v1.GetContractTrendRequest.
 * Use `create(GetContractTrendRequestSchema)` to create a new message.
 */
export const GetContractTrendRequestSchema: GenMessage<GetContractTrendRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 3);

/**
 * ContractTrendDay は 1 日分: その日が供給期間の内側の契約の、その日に効いている契約kW の電圧階級別の合計と件数。
 *
 * @generated from message bffuser.v1.ContractTrendDay
 */
export type ContractTrendDay = Message<"bffuser.v1.ContractTrendDay"> & {
  /**
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * @generated from field: google.type.Decimal low_kw = 2;
   */
  lowKw?: Decimal;

  /**
   * @generated from field: google.type.Decimal high_kw = 3;
   */
  highKw?: Decimal;

  /**
   * @generated from field: google.type.Decimal extra_high_kw = 4;
   */
  extraHighKw?: Decimal;

  /**
   * @generated from field: int32 count = 5;
   */
  count: number;
};

/**
 * Describes the message bffuser.v1.ContractTrendDay.
 * Use `create(ContractTrendDaySchema)` to create a new message.
 */
export const ContractTrendDaySchema: GenMessage<ContractTrendDay> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 4);

/**
 * ContractTrendEvent は範囲の中の供給開始・終了 (その日の契約kW つき)。
 *
 * @generated from message bffuser.v1.ContractTrendEvent
 */
export type ContractTrendEvent = Message<"bffuser.v1.ContractTrendEvent"> & {
  /**
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * @generated from field: bffuser.v1.ContractTrendEventKind kind = 2;
   */
  kind: ContractTrendEventKind;

  /**
   * @generated from field: string customer_name = 3;
   */
  customerName: string;

  /**
   * @generated from field: bffuser.v1.VoltageClass voltage_class = 4;
   */
  voltageClass: VoltageClass;

  /**
   * @generated from field: google.type.Decimal contract_kw = 5;
   */
  contractKw?: Decimal;
};

/**
 * Describes the message bffuser.v1.ContractTrendEvent.
 * Use `create(ContractTrendEventSchema)` to create a new message.
 */
export const ContractTrendEventSchema: GenMessage<ContractTrendEvent> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 5);

/**
 * ContractTrendKpi は範囲の合計契約kW の平均 (四捨五入)・最小・最大。範囲の最終日の値は days の末尾。
 *
 * @generated from message bffuser.v1.ContractTrendKpi
 */
export type ContractTrendKpi = Message<"bffuser.v1.ContractTrendKpi"> & {
  /**
   * @generated from field: google.type.Decimal avg_total_kw = 1;
   */
  avgTotalKw?: Decimal;

  /**
   * @generated from field: google.type.Decimal min_total_kw = 2;
   */
  minTotalKw?: Decimal;

  /**
   * @generated from field: google.type.Decimal max_total_kw = 3;
   */
  maxTotalKw?: Decimal;
};

/**
 * Describes the message bffuser.v1.ContractTrendKpi.
 * Use `create(ContractTrendKpiSchema)` to create a new message.
 */
export const ContractTrendKpiSchema: GenMessage<ContractTrendKpi> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 6);

/**
 * @generated from message bffuser.v1.GetContractTrendResponse
 */
export type GetContractTrendResponse = Message<"bffuser.v1.GetContractTrendResponse"> & {
  /**
   * 範囲の日数分 (日付順)。
   *
   * @generated from field: repeated bffuser.v1.ContractTrendDay days = 1;
   */
  days: ContractTrendDay[];

  /**
   * @generated from field: repeated bffuser.v1.ContractTrendEvent events = 2;
   */
  events: ContractTrendEvent[];

  /**
   * days が空の時は未設定。
   *
   * @generated from field: optional bffuser.v1.ContractTrendKpi kpi = 3;
   */
  kpi?: ContractTrendKpi;
};

/**
 * Describes the message bffuser.v1.GetContractTrendResponse.
 * Use `create(GetContractTrendResponseSchema)` to create a new message.
 */
export const GetContractTrendResponseSchema: GenMessage<GetContractTrendResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 7);

/**
 * @generated from message bffuser.v1.ListCustomerSupplyPointsResponse
 */
export type ListCustomerSupplyPointsResponse = Message<"bffuser.v1.ListCustomerSupplyPointsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.CustomerSupplyPoint supply_points = 1;
   */
  supplyPoints: CustomerSupplyPoint[];
};

/**
 * Describes the message bffuser.v1.ListCustomerSupplyPointsResponse.
 * Use `create(ListCustomerSupplyPointsResponseSchema)` to create a new message.
 */
export const ListCustomerSupplyPointsResponseSchema: GenMessage<ListCustomerSupplyPointsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 8);

/**
 * @generated from message bffuser.v1.GetCustomerSupplyPointFormOptionsRequest
 */
export type GetCustomerSupplyPointFormOptionsRequest = Message<"bffuser.v1.GetCustomerSupplyPointFormOptionsRequest"> & {
  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode: AreaCode;
};

/**
 * Describes the message bffuser.v1.GetCustomerSupplyPointFormOptionsRequest.
 * Use `create(GetCustomerSupplyPointFormOptionsRequestSchema)` to create a new message.
 */
export const GetCustomerSupplyPointFormOptionsRequestSchema: GenMessage<GetCustomerSupplyPointFormOptionsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 9);

/**
 * @generated from message bffuser.v1.GetCustomerSupplyPointFormOptionsResponse
 */
export type GetCustomerSupplyPointFormOptionsResponse = Message<"bffuser.v1.GetCustomerSupplyPointFormOptionsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.RetailerOption retailer_options = 1;
   */
  retailerOptions: RetailerOption[];

  /**
   * @generated from field: repeated bffuser.v1.CustomerOption customer_options = 2;
   */
  customerOptions: CustomerOption[];

  /**
   * @generated from field: repeated bffuser.v1.ContractorOption contractor_options = 3;
   */
  contractorOptions: ContractorOption[];
};

/**
 * Describes the message bffuser.v1.GetCustomerSupplyPointFormOptionsResponse.
 * Use `create(GetCustomerSupplyPointFormOptionsResponseSchema)` to create a new message.
 */
export const GetCustomerSupplyPointFormOptionsResponseSchema: GenMessage<GetCustomerSupplyPointFormOptionsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 10);

/**
 * @generated from message bffuser.v1.CreateCustomerSupplyPointRequest
 */
export type CreateCustomerSupplyPointRequest = Message<"bffuser.v1.CreateCustomerSupplyPointRequest"> & {
  /**
   * @generated from field: bffuser.v1.ContractStage contract_stage = 1;
   */
  contractStage: ContractStage;

  /**
   * @generated from oneof bffuser.v1.CreateCustomerSupplyPointRequest.customer
   */
  customer: {
    /**
     * @generated from field: string existing_customer_id = 2;
     */
    value: string;
    case: "existingCustomerId";
  } | {
    /**
     * @generated from field: string new_customer_name = 3;
     */
    value: string;
    case: "newCustomerName";
  } | { case: undefined; value?: undefined };

  /**
   * 新しい需要家の契約者を既存から選ぶ時の Id。new_contractor_name とどちらか一方を指定する。
   *
   * @generated from field: optional string contractor_id = 4;
   */
  contractorId?: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 5;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: optional string retailer_business_code = 6;
   */
  retailerBusinessCode?: string;

  /**
   * @generated from field: bffuser.v1.VoltageClass voltage_class = 7;
   */
  voltageClass: VoltageClass;

  /**
   * @generated from field: optional string supply_point_specific_number = 8;
   */
  supplyPointSpecificNumber?: string;

  /**
   * @generated from field: optional google.type.Decimal contract_kw = 9;
   */
  contractKw?: Decimal;

  /**
   * @generated from field: google.type.Date supply_start_date = 10;
   */
  supplyStartDate?: Date;

  /**
   * @generated from field: optional google.type.Date supply_end_date = 11;
   */
  supplyEndDate?: Date;

  /**
   * @generated from field: bffuser.v1.PrivateGeneration private_generation = 12;
   */
  privateGeneration?: PrivateGeneration;

  /**
   * 新しい需要家の契約者を新しく作る時の名前。contractor_id が無い時は必須 (CONTRACTOR_REQUIRED)。
   *
   * @generated from field: optional string new_contractor_name = 13;
   */
  newContractorName?: string;
};

/**
 * Describes the message bffuser.v1.CreateCustomerSupplyPointRequest.
 * Use `create(CreateCustomerSupplyPointRequestSchema)` to create a new message.
 */
export const CreateCustomerSupplyPointRequestSchema: GenMessage<CreateCustomerSupplyPointRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 11);

/**
 * @generated from message bffuser.v1.CreateCustomerSupplyPointResponse
 */
export type CreateCustomerSupplyPointResponse = Message<"bffuser.v1.CreateCustomerSupplyPointResponse"> & {
  /**
   * @generated from field: string customer_supply_point_id = 1;
   */
  customerSupplyPointId: string;

  /**
   * @generated from field: string customer_id = 2;
   */
  customerId: string;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.CreateCustomerSupplyPointResponse.
 * Use `create(CreateCustomerSupplyPointResponseSchema)` to create a new message.
 */
export const CreateCustomerSupplyPointResponseSchema: GenMessage<CreateCustomerSupplyPointResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 12);

/**
 * ProspectNumber は見込みの供給地点特定番号の変更。空文字 = 消す。
 *
 * @generated from message bffuser.v1.ProspectNumber
 */
export type ProspectNumber = Message<"bffuser.v1.ProspectNumber"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;
};

/**
 * Describes the message bffuser.v1.ProspectNumber.
 * Use `create(ProspectNumberSchema)` to create a new message.
 */
export const ProspectNumberSchema: GenMessage<ProspectNumber> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 13);

/**
 * @generated from message bffuser.v1.UpdateCustomerSupplyPointRequest
 */
export type UpdateCustomerSupplyPointRequest = Message<"bffuser.v1.UpdateCustomerSupplyPointRequest"> & {
  /**
   * @generated from field: string customer_supply_point_id = 1;
   */
  customerSupplyPointId: string;

  /**
   * @generated from field: optional google.type.Decimal contract_kw = 2;
   */
  contractKw?: Decimal;

  /**
   * @generated from field: google.type.Date supply_start_date = 3;
   */
  supplyStartDate?: Date;

  /**
   * @generated from field: optional google.type.Date supply_end_date = 4;
   */
  supplyEndDate?: Date;

  /**
   * 見込み専用。未指定 = 番号を変えない。
   *
   * @generated from field: optional bffuser.v1.ProspectNumber prospect_number = 5;
   */
  prospectNumber?: ProspectNumber;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 6;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * @generated from field: optional bfftypes.v1.AreaCode area_code = 7;
   */
  areaCode?: AreaCode;

  /**
   * @generated from field: optional bffuser.v1.VoltageClass voltage_class = 8;
   */
  voltageClass?: VoltageClass;

  /**
   * @generated from field: optional string supply_point_specific_number = 9;
   */
  supplyPointSpecificNumber?: string;

  /**
   * @generated from field: optional string retailer_business_code = 10;
   */
  retailerBusinessCode?: string;

  /**
   * @generated from field: optional bffuser.v1.KwPeriodList kw_periods = 11;
   */
  kwPeriods?: KwPeriodList;
};

/**
 * Describes the message bffuser.v1.UpdateCustomerSupplyPointRequest.
 * Use `create(UpdateCustomerSupplyPointRequestSchema)` to create a new message.
 */
export const UpdateCustomerSupplyPointRequestSchema: GenMessage<UpdateCustomerSupplyPointRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 14);

/**
 * @generated from message bffuser.v1.UpdateCustomerSupplyPointResponse
 */
export type UpdateCustomerSupplyPointResponse = Message<"bffuser.v1.UpdateCustomerSupplyPointResponse"> & {
  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 1;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateCustomerSupplyPointResponse.
 * Use `create(UpdateCustomerSupplyPointResponseSchema)` to create a new message.
 */
export const UpdateCustomerSupplyPointResponseSchema: GenMessage<UpdateCustomerSupplyPointResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 15);

/**
 * @generated from message bffuser.v1.UpdateCustomerRequest
 */
export type UpdateCustomerRequest = Message<"bffuser.v1.UpdateCustomerRequest"> & {
  /**
   * @generated from field: string customer_id = 1;
   */
  customerId: string;

  /**
   * @generated from field: string customer_name = 2;
   */
  customerName: string;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 3;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * @generated from field: optional string contractor_id = 4;
   */
  contractorId?: string;
};

/**
 * Describes the message bffuser.v1.UpdateCustomerRequest.
 * Use `create(UpdateCustomerRequestSchema)` to create a new message.
 */
export const UpdateCustomerRequestSchema: GenMessage<UpdateCustomerRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 16);

/**
 * @generated from message bffuser.v1.UpdateCustomerResponse
 */
export type UpdateCustomerResponse = Message<"bffuser.v1.UpdateCustomerResponse"> & {
  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 1;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.UpdateCustomerResponse.
 * Use `create(UpdateCustomerResponseSchema)` to create a new message.
 */
export const UpdateCustomerResponseSchema: GenMessage<UpdateCustomerResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 17);

/**
 * @generated from message bffuser.v1.ConvertProspectToContractRequest
 */
export type ConvertProspectToContractRequest = Message<"bffuser.v1.ConvertProspectToContractRequest"> & {
  /**
   * @generated from field: string customer_supply_point_id = 1;
   */
  customerSupplyPointId: string;

  /**
   * @generated from field: string supply_point_specific_number = 2;
   */
  supplyPointSpecificNumber: string;

  /**
   * @generated from field: optional string retailer_business_code = 3;
   */
  retailerBusinessCode?: string;

  /**
   * @generated from field: optional google.type.Decimal contract_kw = 4;
   */
  contractKw?: Decimal;

  /**
   * @generated from field: google.type.Date supply_start_date = 5;
   */
  supplyStartDate?: Date;

  /**
   * @generated from field: optional google.type.Date supply_end_date = 6;
   */
  supplyEndDate?: Date;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 7;
   */
  expectedUpdatedAt?: Timestamp;

  /**
   * @generated from field: optional bffuser.v1.KwPeriodList kw_periods = 8;
   */
  kwPeriods?: KwPeriodList;
};

/**
 * Describes the message bffuser.v1.ConvertProspectToContractRequest.
 * Use `create(ConvertProspectToContractRequestSchema)` to create a new message.
 */
export const ConvertProspectToContractRequestSchema: GenMessage<ConvertProspectToContractRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 18);

/**
 * @generated from message bffuser.v1.ConvertProspectToContractResponse
 */
export type ConvertProspectToContractResponse = Message<"bffuser.v1.ConvertProspectToContractResponse"> & {
  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 1;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.ConvertProspectToContractResponse.
 * Use `create(ConvertProspectToContractResponseSchema)` to create a new message.
 */
export const ConvertProspectToContractResponseSchema: GenMessage<ConvertProspectToContractResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 19);

/**
 * @generated from message bffuser.v1.MarkProspectLostRequest
 */
export type MarkProspectLostRequest = Message<"bffuser.v1.MarkProspectLostRequest"> & {
  /**
   * @generated from field: string customer_supply_point_id = 1;
   */
  customerSupplyPointId: string;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.MarkProspectLostRequest.
 * Use `create(MarkProspectLostRequestSchema)` to create a new message.
 */
export const MarkProspectLostRequestSchema: GenMessage<MarkProspectLostRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 20);

/**
 * @generated from message bffuser.v1.MarkProspectLostResponse
 */
export type MarkProspectLostResponse = Message<"bffuser.v1.MarkProspectLostResponse"> & {
  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 1;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.MarkProspectLostResponse.
 * Use `create(MarkProspectLostResponseSchema)` to create a new message.
 */
export const MarkProspectLostResponseSchema: GenMessage<MarkProspectLostResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 21);

/**
 * @generated from message bffuser.v1.GetCustomerSupplyPointDeletabilityRequest
 */
export type GetCustomerSupplyPointDeletabilityRequest = Message<"bffuser.v1.GetCustomerSupplyPointDeletabilityRequest"> & {
  /**
   * @generated from field: string customer_supply_point_id = 1;
   */
  customerSupplyPointId: string;
};

/**
 * Describes the message bffuser.v1.GetCustomerSupplyPointDeletabilityRequest.
 * Use `create(GetCustomerSupplyPointDeletabilityRequestSchema)` to create a new message.
 */
export const GetCustomerSupplyPointDeletabilityRequestSchema: GenMessage<GetCustomerSupplyPointDeletabilityRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 22);

/**
 * @generated from message bffuser.v1.GetCustomerSupplyPointDeletabilityResponse
 */
export type GetCustomerSupplyPointDeletabilityResponse = Message<"bffuser.v1.GetCustomerSupplyPointDeletabilityResponse"> & {
  /**
   * @generated from field: bool deletable = 1;
   */
  deletable: boolean;

  /**
   * @generated from field: optional bffuser.v1.SupplyPointDeleteBlockedReason blocked_reason = 2;
   */
  blockedReason?: SupplyPointDeleteBlockedReason;
};

/**
 * Describes the message bffuser.v1.GetCustomerSupplyPointDeletabilityResponse.
 * Use `create(GetCustomerSupplyPointDeletabilityResponseSchema)` to create a new message.
 */
export const GetCustomerSupplyPointDeletabilityResponseSchema: GenMessage<GetCustomerSupplyPointDeletabilityResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 23);

/**
 * @generated from message bffuser.v1.DeleteCustomerSupplyPointRequest
 */
export type DeleteCustomerSupplyPointRequest = Message<"bffuser.v1.DeleteCustomerSupplyPointRequest"> & {
  /**
   * @generated from field: string customer_supply_point_id = 1;
   */
  customerSupplyPointId: string;

  /**
   * @generated from field: google.protobuf.Timestamp expected_updated_at = 2;
   */
  expectedUpdatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.DeleteCustomerSupplyPointRequest.
 * Use `create(DeleteCustomerSupplyPointRequestSchema)` to create a new message.
 */
export const DeleteCustomerSupplyPointRequestSchema: GenMessage<DeleteCustomerSupplyPointRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 24);

/**
 * @generated from message bffuser.v1.DeleteCustomerSupplyPointResponse
 */
export type DeleteCustomerSupplyPointResponse = Message<"bffuser.v1.DeleteCustomerSupplyPointResponse"> & {
};

/**
 * Describes the message bffuser.v1.DeleteCustomerSupplyPointResponse.
 * Use `create(DeleteCustomerSupplyPointResponseSchema)` to create a new message.
 */
export const DeleteCustomerSupplyPointResponseSchema: GenMessage<DeleteCustomerSupplyPointResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_customer_service, 25);

/**
 * @generated from enum bffuser.v1.ContractTrendEventKind
 */
export enum ContractTrendEventKind {
  /**
   * @generated from enum value: CONTRACT_TREND_EVENT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTRACT_TREND_EVENT_KIND_START = 1;
   */
  START = 1,

  /**
   * @generated from enum value: CONTRACT_TREND_EVENT_KIND_END = 2;
   */
  END = 2,
}

/**
 * Describes the enum bffuser.v1.ContractTrendEventKind.
 */
export const ContractTrendEventKindSchema: GenEnum<ContractTrendEventKind> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_customer_service, 0);

/**
 * CustomerService は顧客管理の需要家一覧・契約推移 (地点の登録・編集・区分の遷移・削除)
 * を扱う。organization_id と acting_member_id は露出させず BFF が eauth セッションから
 * 補完する (multitenant.md)。internalapi.v1.CustomerService の薄い pass-through。
 *
 * @generated from service bffuser.v1.CustomerService
 */
export const CustomerService: GenService<{
  /**
   * @generated from rpc bffuser.v1.CustomerService.ListCustomers
   */
  listCustomers: {
    methodKind: "unary";
    input: typeof ListCustomersRequestSchema;
    output: typeof ListCustomersResponseSchema;
  },
  /**
   * area_code 未指定は全エリア。
   *
   * @generated from rpc bffuser.v1.CustomerService.ListCustomerSupplyPoints
   */
  listCustomerSupplyPoints: {
    methodKind: "unary";
    input: typeof ListCustomerSupplyPointsRequestSchema;
    output: typeof ListCustomerSupplyPointsResponseSchema;
  },
  /**
   * 契約推移の日別集計 (区分「契約」だけ・供給期間内)。
   *
   * @generated from rpc bffuser.v1.CustomerService.GetContractTrend
   */
  getContractTrend: {
    methodKind: "unary";
    input: typeof GetContractTrendRequestSchema;
    output: typeof GetContractTrendResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.CustomerService.GetCustomerSupplyPointFormOptions
   */
  getCustomerSupplyPointFormOptions: {
    methodKind: "unary";
    input: typeof GetCustomerSupplyPointFormOptionsRequestSchema;
    output: typeof GetCustomerSupplyPointFormOptionsResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.CustomerService.CreateCustomerSupplyPoint
   */
  createCustomerSupplyPoint: {
    methodKind: "unary";
    input: typeof CreateCustomerSupplyPointRequestSchema;
    output: typeof CreateCustomerSupplyPointResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.CustomerService.UpdateCustomerSupplyPoint
   */
  updateCustomerSupplyPoint: {
    methodKind: "unary";
    input: typeof UpdateCustomerSupplyPointRequestSchema;
    output: typeof UpdateCustomerSupplyPointResponseSchema;
  },
  /**
   * UpdateCustomer は需要家名を直す (社名変更)。
   *
   * @generated from rpc bffuser.v1.CustomerService.UpdateCustomer
   */
  updateCustomer: {
    methodKind: "unary";
    input: typeof UpdateCustomerRequestSchema;
    output: typeof UpdateCustomerResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.CustomerService.ConvertProspectToContract
   */
  convertProspectToContract: {
    methodKind: "unary";
    input: typeof ConvertProspectToContractRequestSchema;
    output: typeof ConvertProspectToContractResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.CustomerService.MarkProspectLost
   */
  markProspectLost: {
    methodKind: "unary";
    input: typeof MarkProspectLostRequestSchema;
    output: typeof MarkProspectLostResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.CustomerService.GetCustomerSupplyPointDeletability
   */
  getCustomerSupplyPointDeletability: {
    methodKind: "unary";
    input: typeof GetCustomerSupplyPointDeletabilityRequestSchema;
    output: typeof GetCustomerSupplyPointDeletabilityResponseSchema;
  },
  /**
   * @generated from rpc bffuser.v1.CustomerService.DeleteCustomerSupplyPoint
   */
  deleteCustomerSupplyPoint: {
    methodKind: "unary";
    input: typeof DeleteCustomerSupplyPointRequestSchema;
    output: typeof DeleteCustomerSupplyPointResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_customer_service, 0);

